import {
    Box,
    Typography,
    TextField,
    Card,
    Button,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Divider,
    useTheme,
    useMediaQuery
} from "@mui/material"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import React, { useState } from "react"
import {
    Loader
} from "../components/index"
import {
    Message,
    toaster
} from "rsuite"
import { GetCurrentUser } from "../utils/hooks"
import _ from "lodash"
import { useLazyGetInstitutionClassesQuery } from "../Redux/actions/classSetup.action"
import {
    useCreateExamMutation,
    useLazyGetAllExamsQuery,
    useCreateTimetableMutation,
    useLazyGetAllTimetableQuery,
    useAddSujectToTimetableMutation
} from "../Redux/actions/examAction"
import { useNavigate } from "react-router-dom"
import ExamList from "./ExamList"
import ImportTimetableDialog from "./ImportTimetableDialog"

export default function CreateExamTimetablePage() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const navigate = useNavigate()
    const [allExamList, setAllExamList] = useState([])
    const [allTimetableList,setAllTimetableList] = useState([])
    const [examName, setExamName] = useState("")
    const [selectedClass, setSelectedClass] = useState("")
    const [examList, setExamList] = useState([])
    const [selectedExamObj,setExamObj] = useState({})
    // Exam just created; offer to import its timetable straight away
    const [newExam, setNewExam] = useState(null)

    const [getPlatformClassesAction, getPlatformClassesState] = useLazyGetInstitutionClassesQuery()

    const [createExam, createExamState] = useCreateExamMutation()
    const [getAllExam, getAllExamState] = useLazyGetAllExamsQuery()
    const [createTimetable,createTimetableState] = useCreateTimetableMutation()
    const [fetchAllExamTimetable,fetchAllExamTimetableState] = useLazyGetAllTimetableQuery()
    const [addSubject,addSubjectState] = useAddSujectToTimetableMutation()


    React.useEffect(() => {
        fetchPlatformData()

        return ()=> {
            createExamState.reset()
        }
    }, [])
    React.useEffect(() => {
        if (getAllExamState.status === "fulfilled") {
            const list = _.get(getAllExamState, "currentData.list", [])
            setAllExamList([...list])
        }
    }, [getAllExamState.status])
    React.useEffect(()=>{
        if(createExamState.status === "fulfilled"){
            const message = _.get(createExamState, "data.message", "Exam created")
            toaster.push(<Message type="success">{message}</Message>, { placement: "topCenter" })
            const exam = _.get(createExamState, "data.exam", null)
            if (exam && exam.id) {
                setNewExam(exam)
            }
            setExamName("")
            fetchPlatformData()
            createExamState.reset()
        } else if (createExamState.status === "rejected") {
            const detail = _.get(createExamState, "error.data.detail", null)
            toaster.push(
                <Message type="error">{_.isString(detail) ? detail : "Could not create the exam"}</Message>,
                { placement: "topCenter" }
            )
            createExamState.reset()
        }
    },[createExamState.status])

    React.useEffect(()=>{
        if(fetchAllExamTimetableState.status === "fulfilled" && fetchAllExamTimetableState.isSuccess){
            const timetableList = _.get(fetchAllExamTimetableState,"currentData.list",[])
            let examName = _.get(selectedExamObj,"exam.exam_name","")
            let class_id = _.get(selectedExamObj,"exam.class_ref","")
            const findTimetable = Array.isArray(timetableList) && timetableList.length > 0 && timetableList.find(exam => exam.exam_name == examName && exam.class_ref == class_id)
            const timetables = findTimetable ? _.get(findTimetable,"timetables",[]) : []
            setAllTimetableList(timetables)
        }else{
            setAllTimetableList([])
        }
    },[fetchAllExamTimetableState.status])
    React.useEffect(()=>{
        if(addSubjectState.status === "fulfilled"){
            const message = _.get(addSubjectState,"data.message","Subject scheduling successfully!")
            toaster.push(<Message type="success" >{message}</Message>,{placement:"topCenter"})
            const school_id = _.get(selectedExamObj,"exam.school_ref",null)
            const class_id = _.get(selectedExamObj,"exam.class_ref",null)
            if(school_id && class_id){
                handleFetchAllExamTimetable(class_id,school_id)
            }
            addSubjectState.reset()
        }else if(addSubjectState.status === "rejected" || addSubjectState.isError){
            let errMessage_1 = _.get(addSubjectState,"error.data.detail[0].msg",null)
            let errMessage_2 = _.get(addSubjectState,"error.error",null)
            toaster.push(<Message type="error" >{errMessage_1 || errMessage_2}</Message>,{placement:"topCenter"})
            addSubjectState.reset()
        }
    },[addSubjectState.status])
    React.useEffect(()=>{
        if(createTimetableState.isSuccess){
            const message = _.get(createTimetableState,"data.message","")
            toaster.push(<Message type="success" >{message}</Message>,{placement:"topCenter"})
            const class_id = _.get(selectedExamObj,"exam.class_ref",null)
            const school_id = _.get(selectedExamObj,"exam.school_ref",null)
            if(school_id && class_id){
                handleFetchAllExamTimetable(class_id,school_id)
            }
            createTimetableState.reset()
        }
    },[createTimetableState.status])


    function fetchPlatformData() {
        const user = GetCurrentUser()
        if (user) {
            let user_platform = _.get(user, "meta_data.user_platform", null)
            if (user_platform) {
                getPlatformClassesAction({
                    institution_ref: user_platform
                })
                getAllExam({
                    school_id: user_platform
                })
            }
        }
    }

    const classes = React.useMemo(() => {
        if (getPlatformClassesState.isSuccess) {
            let list = _.get(getPlatformClassesState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getPlatformClassesState])



    function handleCreateTimetable(data){
        if(!data) return
        createTimetable(data)
    }
    function handleFetchAllExamTimetable(class_id,school_id){
        if(!class_id || !school_id) return
        fetchAllExamTimetable({
            class_id,
            school_id
        })
    }
    // id is the timetable record's id, not the exam's
    function addSubjectIntoTimetable(timetableId, examId, timetable = []){
        if(!timetableId || !examId || timetable.length === 0) return
        addSubject({
            id: timetableId,
            data:{
                exam_timetable:[...timetable],
                exam_id: examId
            }
        })
    }


    return (
        <Box
            sx={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #2196F3, #3F51B5, #673AB7)",
                p: isMobile ? 1 : 4,
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 900,
                    p: isMobile ? 1 : 4,
                    borderRadius: 4,
                    bgcolor: "#ffffffee",
                    backdropFilter: "blur(10px)",
                }}
            >
                {/* Header */}
                <Box textAlign="center" mb={4}>
                    <CalendarMonthIcon sx={{ fontSize: 60, color: "#673AB7" }} />
                    <Typography variant="h4" fontWeight="bold" mt={1}>
                        Create Exam Timetable
                    </Typography>
                    <Typography sx={{ color: "#555", mt: 1 }}>
                        Schedule subjects, dates, and exam timings.
                    </Typography>
                </Box>

                {/* General Details */}
                <Typography variant="h6" fontWeight="600" mb={2}>
                    Exam Details
                </Typography>

                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, mb: 4 }}>
                    <TextField
                        fullWidth
                        label="Exam Name"
                        placeholder="Example: Half-Yearly Examination"
                        value={examName}
                        onChange={(e) => {
                            setExamName(e.target.value)
                        }}
                    />

                    <FormControl fullWidth>
                        <InputLabel>Class</InputLabel>
                        <Select
                            label="Class"
                            value={selectedClass}
                            onChange={(e) => {
                                let value = e.target.value
                                setSelectedClass(value)
                                let findClass = Array.isArray(classes) && classes.length > 0 && classes.find(i => i.class_name.toLowerCase() === value.toLowerCase())
                                let exam = _.get(findClass, "meta_data.exam", null)
                                if (exam) {
                                    setExamList([...exam])
                                }
                            }}
                        >
                            {
                                Array.isArray(classes) && classes.length > 0 && classes.map((item) => {
                                    return (
                                        <MenuItem key={item.id} value={item.class_name} >{item.class_name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Box>
                <div className="col-md-12" style={{
                    width: "100%"
                }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={()=> {
                            if(!examName || !selectedClass) return
                            const findClass = Array.isArray(classes) && classes.length > 0 && classes.find(cl => cl.class_name === selectedClass)
                            if(!findClass) return
                            const data = {
                                class_ref:findClass.id,
                                school_ref:findClass.institution_ref,
                                exam_name:examName
                            }
                            createExam(data)
                        }}
                    >Create</Button>
                    <Typography sx={{ fontSize: 12, color: "#64748b", mt: 1, textAlign: "center" }}>
                        After creating the exam you can import its subject timetable from an Excel or CSV file.
                    </Typography>
                </div>

                <Divider sx={{ mb: 3 }} />
                <ExamList 
                   examList={allExamList}
                   handleCreateTimetable={handleCreateTimetable}
                   handleFetchAllExamTimetable={handleFetchAllExamTimetable}
                   allTimetableList={allTimetableList}
                   setExamObj={setExamObj}
                   addSubjectIntoTimetable={addSubjectIntoTimetable}
                   classList = {classes}
                />
                <Box textAlign="right" mb={4} m={2}>
                    <Button
                        variant="contained"
                        sx={{ bgcolor: "#4CAF50", "&:hover": { bgcolor: "#45A049" } }}
                        onClick={() => {
                            navigate("/exam/manage")
                        }}
                    >
                        Manage Exam
                    </Button>
                </Box>
            </Card>
            {
                newExam && (
                    <ImportTimetableDialog
                        exam={newExam}
                        className={_.get(classes.find((cl) => cl.id === newExam.class_ref), "class_name", "")}
                        title="Exam created. Import its timetable?"
                        onClose={() => setNewExam(null)}
                        onImported={() => {
                            if (selectedExamObj?.exam?.id === newExam.id) {
                                handleFetchAllExamTimetable(newExam.class_ref, newExam.school_ref)
                            }
                        }}
                    />
                )
            }
            {
                (
                    getPlatformClassesState.isLoading ||
                    createExamState.isLoading ||
                    getAllExamState.isLoading ||
                    createTimetableState.isLoading ||
                    fetchAllExamTimetableState.isLoading ||
                    addSubjectState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    )
}
